import React from 'react';
import { Button } from './ui/button';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('[ErrorBoundary] Caught error:', error, errorInfo);
    this.setState({
      error,
      errorInfo
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50">
          <div className="max-w-2xl mx-auto p-8 bg-white rounded-lg shadow-lg">
            <h1 className="text-3xl font-bold text-red-600 mb-4">⚠️ Something went wrong</h1>
            <p className="text-gray-700 mb-4">
              The page encountered an error. Please try refreshing or go back to the homepage.
            </p>
            
            <details className="mb-4 p-4 bg-gray-100 rounded">
              <summary className="cursor-pointer font-semibold text-gray-800">Error Details</summary>
              <pre className="mt-2 text-xs text-red-600 overflow-auto">
                {this.state.error && this.state.error.toString()}
              </pre>
              <pre className="mt-2 text-xs text-gray-600 overflow-auto">
                {this.state.errorInfo && this.state.errorInfo.componentStack}
              </pre>
            </details>

            <div className="flex gap-4">
              <Button onClick={() => window.location.href = '/'}>
                Go to Homepage
              </Button>
              <Button variant="outline" onClick={() => window.location.reload()}>
                Refresh Page
              </Button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
